<template>
	<PopUp
		title="Auswahl entfernen oder bearbeiten?"
		size="lg"
		hide-actions
		@hidden="$emit('hidden')"
	>
		<div>
			Soll
			<Label :characteristic="characteristic" class="font-weight-extra-bold"/>
			bearbeitet oder entfernt werden?
		</div>
		<div class="mt-5 d-flex align-items-center justify-content-end flex-column-reverse flex-md-row">
			<a href="#" @click.prevent="$emit('hidden')">Abbrechen</a>
			<Button
				text="Entfernen"
				icon="bin"
				class="ml-3 mb-2 mb-md-0"
				@click="$emit('remove')"
			/>
			<Button
				text="Bearbeiten"
				icon="pencil"
				class="ml-3 mb-2 mb-md-0"
				@click="$emit('edit')"
			/>
		</div>
	</PopUp>
</template>
<script>
import Label from "@/vue/characteristic/Label.vue"
import PopUp from "@/vue/common/PopUp.vue"
import Button from "@/vue/common/Button.vue";

export default {
	components: {
		Button,
		PopUp,
		Label,
	},

	props: {
		characteristic: {
			type: Object,
			required: true,
		}
	}
}
</script>
